import React from 'react'
import { Link } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import HomeIcon from '@material-ui/icons/Home'
import VolumeUpIcon from '@material-ui/icons/VolumeUp'
import { makePath } from '../../../lib'
import { WID, getWord } from '../../../constants/Language'
import { useContext } from 'react'
import { SoundContext } from '../../../Parts/Sound/SoundProvider'
import { SettingsContext } from '../../../Parts/Settings'

const styles = {
}

const GameMenuItems = (props) => {
  const { classes } = props
  const settingsContext = useContext(SettingsContext)
  const { setOpen } = useContext(SoundContext)
  const { language } = settingsContext

  const gameMenuItemPropsList = [
    {
      name: 'game',
      menuItemProps: {
        component: Link,
        to: makePath('/game', language),
        onClick: () => {
          if (props.onClose) {
            props.onClose()
          }
        }
      },
      listItemTextProps: {
        primary: getWord(WID.GAME_MENU.HOME, language)
      },
      icon: <HomeIcon/>,
    },
    {
      name: 'sounds',
      menuItemProps: {
        onClick: () => {
          setOpen(true)
          if (props.onClose) {
            props.onClose()
          }
        }
      },
      listItemTextProps: {
        primary: getWord(WID.GAME_MENU.SOUND_SETTINGS, language)
      },
      icon: <VolumeUpIcon/>,
    },
  ]

  return (
    <React.Fragment>
      {gameMenuItemPropsList.map((props, index) => 
        <MenuItem key={index} className={classes.menuItem} {...props.menuItemProps} >
          <ListItemIcon className={classes.icon}>
            {props.icon}
          </ListItemIcon>
          <ListItemText inset {...props.listItemTextProps}/>
        </MenuItem>
      )}
    </React.Fragment>
  )
}

export default withStyles(styles, { withTheme: true })(GameMenuItems)


// WEBPACK FOOTER //
// ./src/Pages/Game/components/GameMenuItems.js